import BaseView from './BaseView';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

let view = null;

class Team extends BaseView {
	constructor(container) {
		super(container);

		// this.teamMembers = this.container.querySelectorAll('[data-team-member]');

		this.teamImage = this.container.querySelector('[data-team-image]');
		this.illustrationImage = this.container.querySelector('[data-team-illustration]');

		this.teamSection = this.container.querySelector('[data-team-section]')
		this.teamSectionTop = this.teamSection.getBoundingClientRect().top;

		this.header = this.container.querySelector('[data-header-section]');

		this.headerTrigger = new ScrollTrigger({
			trigger: this.header,
			start: 'bottom top',
			markers: false,
			onEnter: () => {
				document.body.classList.add('body__nav--purple');
			},
			onEnterBack: () => {
				document.body.classList.remove('body__nav--purple');
			}
		});
	}

	init() {
		if (this.teamImage) {
			gsap.fromTo(this.teamImage,
				{
					yPercent: 0,
				},
				{
				yPercent: -30,
				duration: 1,
				ease: "back.inOut(1.7)",
				scrollTrigger: {
					trigger: this.teamImage,
					start: 'top bottom',
					end: 'bottom top',
					markers: false,
					scrub: true,
				}
			});
		}

		if (this.illustrationImage) {
			gsap.fromTo(this.illustrationImage,
				{
					yPercent: 30,
				},
				{
				yPercent: -30,
				duration: 1,
				ease: "back.inOut(1.7)",
				scrollTrigger: {
					trigger: this.illustrationImage,
					start: 'top bottom',
					end: 'bottom top',
					markers: false,
					scrub: true
				}
			})
		}

		if (this.teamMembers) {
			gsap.fromTo(this.teamMembers,
				{
					yPercent: 20,
				},
				{
					yPercent: 0,
					scrollTrigger: {
						trigger: this.teamMembers,
						start: 'top bottom',
						end: 'bottom top',
						markers: false,
						scrub: true
					},
					stagger: {
						each: 0.08,
						ease: "expo.out",
					},
				}
			)
		}
	}

	destroy() {
		super.destroy();
		this.headerTrigger.kill();
	}
}

export default {
	namespace: 'template-team',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Team(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
